const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const BackgroundLabelQueryURL: any = {
    GetBackgroundLabelList: Backofficebff + '/v1/BackgroundLabel/list',
    GetImageBase64: Backofficebff + '/v1/BackgroundLabel/get-image-base64',
};

